<template>
  <div class="c-footer-bar" v-if="courseInfo.saleStatus == 1">
    <!-- <openVip v-if="memberVip == 0"></openVip> -->
    <!-- 个人 -->
    <!-- 个人未购买 courseInfo.hasReadPermission:是否有阅读权限-->
    <!-- 轻课 -->
    <div
      class="c-btns"
      v-if="
        goodsType == constants.goodsType.course ||
        goodsType == constants.goodsType.column
      "
    >
      <div class="c-left">
        <div class="c-gift" v-if="query.isGoodsGroup" @click="paymentBtn(1)">
          <svg class="icon svg-icon" aria-hidden="true">
            <use xlink:href="#icon-zengsongicon" />
          </svg>
          <div class="color-222 f20">{{goodsType == 0 ? '团购' : '赠送'}}</div>
        </div>
        <!--  v-if="!courseInfo.hasReadPermission" -->
        <div class="c-price">
          <span class="fb">
            <span class="f30 fb pr10">¥</span>
            {{ courseInfo.newPrice }}
          </span>
          <img
            v-if="memberVip == 1"
            class="discount-img"
            src="@/assets/images/vip/discount-img.png"
            alt
          />
        </div>
      </div>
      <div class="c-right">
        <gxxt-button
          class="fb"
          :disabled="courseInfo.hasReadPermission"
          type="primary"
          @click="paymentBtn(0)"
        >
          <template v-if="courseInfo.hasReadPermission">已购买</template>
          <template v-else>立即支付</template>
        </gxxt-button>
      </div>
    </div>
    <div
      class="c-btns"
      v-if="
        goodsType == constants.goodsType.offlineClass ||
        goodsType == constants.goodsType.training
      "
    >
      <div class="flex-l flex-dc" @click="customerService">
        <span class="f40 iconfont icon-kefu" v-if="origin != 'miniprogram'"></span>
        <span class="color-222 f20">
          <template v-if="origin != 'miniprogram'">客服</template>
        </span>
      </div>
      <gxxt-group-button class="fb">
        <gxxt-button @click="handler()">查看排期</gxxt-button>
        <gxxt-button type="primary" @click="handler()">立即报名</gxxt-button>
      </gxxt-group-button>
    </div>
  </div>
  <div class="c-off-shelf-wrap" v-if="courseInfo.saleStatus == 0">
    <gxxt-button class="c-off-shelf fb" type="primary" disabled>
      <span class="color-fff">商品已下架</span>
    </gxxt-button>
  </div>
</template>

<script>
import { GxxtGroupButton, GxxtButton } from '@/components'
import { saveUserInfo } from '@/utils/storage'
import { jumpToService } from '@/utils/common'
export default {
  components: {
    GxxtGroupButton,
    GxxtButton,
  },
  props: {
    query: {
      type: Object,
      default: () => {
        return {
          id: '', //goodsId
          adminId: '',
          mobile: '',
          resourceId: '',
          goodsType: '',
          isGoodsGroup: '',
          origin: '',
        }
      },
    },
    courseInfo: {
      type: Object,
      default: () => {
        return {}
      },
    },
    memberVip: {
      type: [Number, String],
      default: '',
    },
    goodsType: {
      type: [Number, String],
      default: '',
    },
  },
  data() {
    return {
      isClicked: false,
    }
  },
  methods: {
    customerService() {
      if (this.origin == 'miniprogram') {
        // jumpToService()
      } else {
        window.location.href = this.constants.service
      }
    },
    handler() {
      this.$router.push({
        path: '/timetable/schedule',
        query: this.query,
      })
    },
    /**
     * @param {Number} type 1团购 0个人
     */
    paymentBtn(type) {
      this.userLoginInfo(type)
    },
    async userLoginInfo(type) {
      if (this.isClicked) return
      this.isClicked = true
      let res = await this.api.login.userLoginInfo()
      if (res && res.code == 200) {
        saveUserInfo(res.data)
        this.$router.push({
          name: 'payment',
          query: {
            ...this.query,
            isGoodsGroup: type,
            memberVip: this.memberVip, //是否会员（0:不是 1：会员）
          },
        })
      }
      this.isClicked = false
    },
  },
}
</script>

<style lang="less" scoped>
.svg-icon {
  width: 40px;
  height: 40px;
}
.c-footer-bar {
  width: 750px;
  position: fixed;
  bottom: 0;
  background: #ffffff;
  z-index: 2;
  .c-btns {
    padding: 16px 32px;
    display: flex;
    justify-content: space-between;
  }
  .c-left {
    display: flex;
    align-items: center;
  }
  .gxxt-button {
    width: 260px;
  }
  .c-gift {
    margin-right: 20px;
  }
  .c-price {
    color: #f50;
    font-size: 40px;
    font-weight: 500;
  }
}
.c-off-shelf-wrap {
  width: 100%;
  position: fixed;
  bottom: 0;
  background: #ffffff;
  padding: 0 32px 32px;
}
.c-off-shelf {
  width: 688px !important;
  display: block;
  margin: 0 auto;
}
</style>